import React from 'react';
import { ComingSoonPage } from '@/routes/organization/ComingSoonPage';

export function LeadEnrichmentComingSoon() {
  return (
    <ComingSoonPage
      title="Lead Enrichment Tool"
      description="Enrich leads with firmographic and contact insights."
      icon={(
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m8-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )}
      features={[
        'Upload CSV of leads for bulk processing',
        'Basic company website and LinkedIn lookups',
        'CSV export of enriched records',
      ]}
    />
  );
}


